import { compose } from "redux";
import React, { PureComponent } from "react";
import EmployeeCardHeader from "features/planner/employee/components/EmployeeCardHeader";

class SubContractorCardHeader extends PureComponent {
  render() {
    const { match } = this.props;

    return <EmployeeCardHeader match={match} />;
  }
}

export default compose()(SubContractorCardHeader);
